"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSelectInputStyles = void 0;
var theme_1 = __importDefault(require("../../theme"));
function getSelectInputStyles(styles) {
    return {
        //@ts-ignore
        menuPortal: function (base) {
            return __assign(__assign(__assign({}, base), { zIndex: 9999 }), styles === null || styles === void 0 ? void 0 : styles.menuPortal);
        },
        //@ts-ignore
        control: function (base) {
            return __assign(__assign(__assign({}, base), { fontSize: theme_1.default.fontSizes.regular, color: theme_1.default.colorsPalette.gray.light, border: "none", borderRadius: "0", boxShadow: "none", "&:hover": {
                    border: "none",
                    boxShadow: "none",
                }, "&:focus": { border: "none", boxShadow: "none" }, "&:active": { border: "none", boxShadow: "none" } }), styles === null || styles === void 0 ? void 0 : styles.control);
        },
        //@ts-ignore
        container: function (base) {
            return __assign(__assign(__assign({}, base), { width: "100%", border: "none", borderBottom: "2px solid " + theme_1.default.colorsPalette.gray.lighter, "&:hover": {
                    borderBottom: "2px solid " + theme_1.default.colorsPalette.blue.default,
                } }), styles === null || styles === void 0 ? void 0 : styles.container);
        },
        //@ts-ignore
        valueContainer: function (base) {
            return __assign(__assign(__assign({}, base), { padding: "8px 0", color: theme_1.default.colorsPalette.gray.light }), styles === null || styles === void 0 ? void 0 : styles.valueContainer);
        },
        indicatorContainer: function () {
            return styles === null || styles === void 0 ? void 0 : styles.indicatorContainer;
        },
        indicatorSeparator: function () {
            return __assign({ display: "none" }, styles === null || styles === void 0 ? void 0 : styles.indicatorSeparator);
        },
        dropdownIndicator: function () {
            return styles === null || styles === void 0 ? void 0 : styles.dropdownIndicator;
        },
        //@ts-ignore
        singleValue: function (base) {
            return __assign(__assign(__assign({}, base), { marginLeft: "0", color: theme_1.default.colorsPalette.gray.light }), styles === null || styles === void 0 ? void 0 : styles.singleValue);
        },
        //@ts-ignore
        placeholder: function (base) {
            return __assign(__assign(__assign({}, base), { marginLeft: "0" }), styles === null || styles === void 0 ? void 0 : styles.placeholder);
        },
        //@ts-ignore
        menu: function (base) {
            return __assign(__assign(__assign({}, base), { border: "none", color: "hsl(221,22%,66%)", fontSize: 14, padding: 16, boxShadow: "0px 0px 7px 20px rgba(0,0,0,0), 0 3px 5px 5px rgba(0,0,0,0.03)", minWidth: 180 }), styles === null || styles === void 0 ? void 0 : styles.menu);
        },
        //@ts-ignore
        option: function (base, state) {
            return __assign(__assign(__assign({}, base), { border: "none", color: state.isSelected
                    ? theme_1.default.colorsPalette.blue.default
                    : "hsl(221,22%,66%)", backgroundColor: state.isSelected
                    ? theme_1.default.colorsPalette.blue.lighter
                    : state.isFocused
                        ? theme_1.default.colorsPalette.blue.lighter
                        : "transparent", borderRadius: 5, cursor: "pointer", padding: "12px 20px" }), styles === null || styles === void 0 ? void 0 : styles.option);
        },
    };
}
exports.getSelectInputStyles = getSelectInputStyles;
//# sourceMappingURL=styles.js.map